/* eslint-disable no-restricted-syntax */
import MicroCMSAdapter from "./_MicroCMSAdapter";
import { makeExhibitorCard } from "./_card-utils";
import { IS_DEBUG, THEME_LIST } from "./_constants";



const microCMSAdapter = new MicroCMSAdapter();

const exhibitorListElementMap = Object.fromEntries(THEME_LIST.map((theme) => {
  const exhibitorListElement = document.querySelector<HTMLElement>(
    `.p-archive-exhibitors-section-main__exhibitor-list--${theme}`
  );
  if (!exhibitorListElement) {
    throw new Error("exhibitorListElement is null");
  }
  return [
    theme,
    exhibitorListElement,
  ];
}));

function myError(errorString: string) {
  for (const exhibitorListElement of Object.values(exhibitorListElementMap)) {
    const errorElement = document.createElement("div");
    errorElement.classList.add("p-archive-exhibitors-section-main__error");
    errorElement.textContent = errorString;
    exhibitorListElement.appendChild(errorElement);
  }

}

microCMSAdapter.getExhibitorListAsync().then((listResponse) => {
  const exhibitorList = listResponse.contents;
  for (const exhibitor of exhibitorList) {
    if (exhibitor.theme.length !== 1) {
      throw new Error("exhibitor.theme.length must be 1");
    }
    const exhibitorListElement = exhibitorListElementMap[exhibitor.theme[0]];
    if (!exhibitorListElement) {
      throw new Error("exhibitorListElement is null");
    }

    const exhibitorElement = document.createElement("article");
    exhibitorElement.classList.add("p-archive-exhibitors-section-main__exhibitor");
    exhibitorListElement.appendChild(exhibitorElement);
    const cardElement = makeExhibitorCard(exhibitor);
    exhibitorElement.appendChild(cardElement);

  }


  if (IS_DEBUG) {
    console.log(exhibitorList);
  }
}).catch((error) => {
  myError(`error.message: ${error.message}`);
  console.error(error);
});

